import { format } from 'date-fns';
import { memo } from 'react';

import { type Notification } from '@air/api/types';
import { type NotificationsItemProps } from '@air/component-notifications';
import { parseAirDateToISO } from '@air/utilities';

import { NotificationBaseItem } from '~/components/AirNotifications/components/NotificationBaseItem';
import { NotificationShareLinkIcon } from '~/components/AirNotifications/components/NotificationShareLinkIcon';
import { useShortUrlNotificationParentName } from '~/components/AirNotifications/hooks/useShortUrlNotificationParentName';

type NotificationShareLinkExpiredTypeProps = {
  notification: Notification<'shareLinkExpired_userIsShareLinkCreator', 'account'>;
} & Pick<NotificationsItemProps, 'onClick'>;

export const NotificationShareLinkExpiredType = memo(
  ({ notification, onClick }: NotificationShareLinkExpiredTypeProps) => {
    const { shortUrl, expirationDate } = notification.data;

    const date = new Date(parseAirDateToISO(expirationDate));

    const { shortUrlParentName } = useShortUrlNotificationParentName(shortUrl);

    return (
      <NotificationBaseItem
        meta={shortUrlParentName ? `in ${shortUrlParentName}` : ''}
        onClick={onClick}
        notification={notification}
        prefix={<NotificationShareLinkIcon isBroken />}
        title={
          <>
            A link to <b>{shortUrl.objectName}</b> expired on {format(date, 'MMM d')}
          </>
        }
      />
    );
  },
);

NotificationShareLinkExpiredType.displayName = 'NotificationShareLinkExpiredType';
